module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/370.3b896a6d.png";